import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

type Step = "register" | "confirm";

export default function SignupPage() {
  const { signUp, confirm, signIn } = useAuth();
  const nav = useNavigate();
  const [step, setStep] = useState<Step>("register");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onRegister(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await signUp(email, pw, name);
      setStep("confirm");
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Signup failed");
    } finally {
      setBusy(false);
    }
  }

  async function onConfirm(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await confirm(email, code);
      await signIn(email, pw);
      nav("/broadcast");
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Confirmation failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h1>{step === "register" ? "Create broadcaster account" : "Check your email"}</h1>
      {step === "register" ? (
        <form onSubmit={onRegister}>
          <label>
            Display name
            <input value={name} required onChange={(e) => setName(e.target.value)} />
          </label>
          <label>
            Email
            <input type="email" value={email} required onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            Password (10+ chars, includes a number)
            <input type="password" value={pw} minLength={10} required onChange={(e) => setPw(e.target.value)} />
          </label>
          {err && <p className="err">{err}</p>}
          <button type="submit" disabled={busy}>{busy ? "Creating…" : "Create account"}</button>
        </form>
      ) : (
        <form onSubmit={onConfirm}>
          <p>We sent a 6-digit code to <strong>{email}</strong>.</p>
          <label>
            Confirmation code
            <input value={code} required onChange={(e) => setCode(e.target.value)} />
          </label>
          {err && <p className="err">{err}</p>}
          <button type="submit" disabled={busy}>{busy ? "Verifying…" : "Verify & go live"}</button>
        </form>
      )}
      <p>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </div>
  );
}
